var exports = {
  "e6": "AddFavoriteChannelModal.module__selectContainer___aEZSMU",
  "yc": "AddFavoriteChannelModal.module__checkboxRow___aEZSMU",
  "Dq": "AddFavoriteChannelModal.module__checkboxText___aEZSMU",
  "gs": "AddFavoriteChannelModal.module__scrollerContainer___aEZSMU",
  "o5": "AddFavoriteChannelModal.module__channelList___aEZSMU",
  "p$": "AddFavoriteChannelModal.module__emptyState___aEZSMU",
  "Km": "AddFavoriteChannelModal.module__categoryHeader___aEZSMU",
  "WG": "AddFavoriteChannelModal.module__channelRow___aEZSMU",
  "uM": "AddFavoriteChannelModal.module__channelIconContainer___aEZSMU",
  "p": "AddFavoriteChannelModal.module__channelIcon___aEZSMU",
  "HA": "AddFavoriteChannelModal.module__channelName___aEZSMU",
  "tN": "AddFavoriteChannelModal.module__channelActions___aEZSMU",
};

module.exports = exports;
